import React, { useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// import { JVInput } from "../../shared/Hinput";

import { set } from "date-fns";
import { baseUrl } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";

const emailSchema = yup.object({
  email: yup.string().email().required("Email is required*"),
});

const otpSchema = yup.object({
  otp: yup.string().required("OTP is required*"),
});

const newPasswordSchema = yup.object({
  newPassword: yup
    .string()
    // .min(8, "Password must be at least 8 characters long")
    .nullable(),
  confirmPassword: yup
    .string()
    //.oneOf([yup.ref("newPassword")], "Passwords must match")
    .nullable(),
});

const ForgotPassword = () => {
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [vwPassword, setVwPassword] = useState(false);
  const [vwCnfPassword, setVwCnfPassword] = useState(false);
  const [password, setPassword] = useState<string>("");
  const [confrimPassword, setConfrimPassword] = useState<string>("");
  const toast = useRef<Toast>(null);

  const {
    control: emailControl,
    handleSubmit: handleEmailSubmit,
    formState: { errors: emailErrors },
    reset: resetEmailForm,
  } = useForm({
    resolver: yupResolver(emailSchema),
  });

  const {
    control: otpControl,
    handleSubmit: handleOtpSubmit,
    formState: { errors: otpErrors },
    reset: resetOtpForm,
  } = useForm({
    resolver: yupResolver(otpSchema),
  });

  const {
    control: newPasswordControl,
    handleSubmit: handleNewPasswordSubmit,
    formState: { errors: newPasswordErrors },
    reset: resetNewPasswordForm,
  } = useForm({
    resolver: yupResolver(newPasswordSchema),
  });

  const onSubmitEmail = async (data: any) => {
    try {
      setLoading(true);
      const response = await fetch(baseUrl + "External_User_Mast/forgotpassword?first=1", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (response.ok) {
        //console.log('OTP sent to email');
        setEmail(data.email);
        setStep("otp");
        resetEmailForm();
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Email not found",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error during forgot password request:", error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred while sending OTP",
        life: 3000,
      });
    }
    setLoading(false);
  };

  const onSubmitOTP = async (data: any) => {
    try {
      setLoading(true);
      const response = await fetch(baseUrl + "External_User_Mast/verifyotp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, otp: data.otp }),
      });
      if (response.ok) {
        //console.log('OTP verified successfully');
        setStep("newPassword");
        setShowPasswordForm(true);
        resetOtpForm();
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Invalid OTP",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      toast.current?.show({ severity: "error", summary: "Error", detail: "An error occurred while verifying OTP", life: 3000, });
    }
    setLoading(false);
  };

  const onSubmitNewPassword = async (data: any) => {
    if (password.trim() === "" || confrimPassword.trim() === "") {
      toast.current?.show({ severity: "error", summary: "Error", detail: "Please Enter Password", life: 3000, });
    } else if (password.trim().length < 8) {
      toast.current?.show({ severity: "error", summary: "Error", detail: "Password must be at least 8 characters long", life: 3000, });
    } else if (password.trim() !== confrimPassword.trim()) {
      toast.current?.show({ severity: "error", summary: "Error", detail: "Confrim Password do not match", life: 3000, });
    } else {
      try {
        setLoading(true);
        const newPasswordData = {
          email,
          newPassword: password.trim(),
        };

        const response = await fetch(baseUrl + "External_User_Mast/resetpassword", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newPasswordData),
        });
        if (response.ok) {
          //console.log('Password reset successfully');
          setStep("success");
          resetNewPasswordForm();
          sessionStorage.clear();
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Password reset failed",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error during password reset:", error);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "An error occurred while resetting password",
          life: 3000,
        });
      }
      setLoading(false);
    }
  };

  const handleGoToLogin = () => {
    window.location.href = "/";
  };

  return (
    <div className="flex align-items-center justify-content-center h-screen">
      <Toast ref={toast} />
      <div className="surface-card p-4 shadow-2 border-round  lg:w-4">
        <div className="text-center mb-5">
          <img
            src="img/logo.png"
            alt="logo"
            height={50}
            width={250}
            className="mb-3"
          />
        </div>
        {step === "email" && (
          <form
            onSubmit={handleEmailSubmit(onSubmitEmail)}
            className="p-fluid formgrid grid mt-6 "
          >
            <JVInput
              column={1}
              label="Email"
              control={emailControl}
              name="email"
            //   error={emailErrors.email?.message}
            />
            <div className="col-12 md:col-12 mt-6 text-center">
              <Button
                type="submit"
                loading={loading}
                label="Send OTP"
                icon="pi pi-envelope"
                className="w-full"
              />
            </div>
          </form>
        )}
        {step === "otp" && (
          <form
            onSubmit={handleOtpSubmit(onSubmitOTP)}
            className="p-fluid formgrid grid mt-6 "
          >
            <p style={{ fontWeight: "bold", color: "red", textAlign: "center" }}>An OTP has been sent on your mail id, please check and enter otp here.</p>
            <JVInput
              column={1}
              label="OTP"
              control={otpControl}
              name="otp"
            //   error={otpErrors.otp?.message}
            />
            <div className="col-12 md:col-12 mt-6 text-center">
              <Button
                type="submit"
                loading={loading}
                label="Verify OTP"
                icon="pi pi-check"
                className="w-full"
              />
            </div>
          </form>
        )}
        {step === "newPassword" && showPasswordForm && (
          <form
            onSubmit={handleNewPasswordSubmit(onSubmitNewPassword)}
            className="p-fluid formgrid grid mt-6 "
          >
            {/* <JVInput
              column={1}
              label="New Password"
              control={newPasswordControl}
              name="newPassword"
            //   error={newPasswordErrors.newPassword?.message}
            />
            <JVInput
              column={1}
              label="Confirm Password"
              control={newPasswordControl}
              name="confirmPassword"
            // error={newPasswordErrors.confirmPassword?.message}
            /> */}
            <div className="flex flex-column w-full">
              <div className="p-inputgroup flex-1 w-full">
                {/* <JVInput required label="Password:" type={vwPassword ? "text" : "password"} control={control} name="visa_Name" error={errors.password?.message} /> */}
                <InputText placeholder="Password" value={password} className="h-4rem" type={vwPassword ? "text" : "password"} onChange={(e) => setPassword(e.target.value)} />
                {!vwPassword && <Button icon="pi pi-eye" className="border-none surface-600 h-4rem" onClick={() => setVwPassword(prev => prev = true)} />}
                {vwPassword && <Button icon="pi pi-eye-slash" className="border-none surface-600 h-4rem" onClick={() => setVwPassword(prev => prev = false)} />}
              </div>
              <div className="p-inputgroup flex-1 mt-5 w-full">
                {/* <JVInput required label="Confrim Password:" type={vwCnfPassword ? "text" : "password"} control={control} name="visa_Name" error={errors.password?.message} /> */}
                <InputText placeholder="Confrim Password" value={confrimPassword} className="h-4rem" type={vwCnfPassword ? "text" : "password"} onChange={(e) => setConfrimPassword(e.target.value)} />
                {!vwCnfPassword && <Button icon="pi pi-eye" className="border-none surface-600 h-4rem" onClick={() => setVwCnfPassword(prev => prev = true)} />}
                {vwCnfPassword && <Button icon="pi pi-eye-slash" className="border-none surface-600 h-4rem" onClick={() => setVwCnfPassword(prev => prev = false)} />}
              </div>
            </div>
            <div className="col-12 md:col-12 mt-6 text-center">
              <Button
                type="submit"
                loading={loading}
                label="Reset Password"
                icon="pi pi-key"
                className="w-full"
              />
            </div>
          </form>
        )}
        {step === "success" && (
          <div className="text-center">
            <p>Your password has been reset successfully.</p>
            <Button
              label="Go to Login"
              icon="pi pi-sign-in"
              className="w-full"
              onClick={handleGoToLogin}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
